export const opinion = [
    {
        id: "content-opinion-a-deeper-look",
        name: "より深い外観",
        articles: [
            {
                id: "7c4b6a7e-1f91-4e43-b099-a72aea0fa6c7",
                class: "columns-3-wide",
                header: "最新の事実",
                url: "#",
                image: {
                    src: "assets/images/milad-fakurian-58Z17lnVS4U-unsplash_684.jpg",
                    alt: "プレースホルダー",
                    width: "684",
                    height: "385",
                },
                meta: {
                    tag: {
                        type: "breaking",
                        label: "速報",
                    },
                },
                title: "オールドアンドネトゥスとマレスアダの飢erと醜い法執行機関。抗酸化物質を嫌い、モーリスはアメットの塊を座らせます。サッカーの臨床矢印は、フットボールの週末の憎しみを抱かせません。",
                type: "text",
                content:
                    "とんでもないマウス最大のヴィタエウルトリシーズライオン。キャンセルと人生の開発者は誰でも。ニブの前に。中国のナムスロートチョコレートのティーンエイジャーは価格まで。サッカープロパガンダのチョコレートフットボールバスケットボールのキャリア著者。",
            },
            {
                id: "0d292bbd-e6da-499b-8008-652d51e3b26d",
                class: "columns-3-narrow",
                header: "私たちの心のトップ",
                url: "#",
                image: {
                    src: "assets/images/no-revisions-UhpAf0ySwuk-unsplash_336.jpg",
                    alt: "プレースホルダー",
                    width: "336",
                    height: "189",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "臨床の価格温度価格を作成してください。ランニングロケモーリスレンジジャスミンを実現します。",
                type: "text",
                content:
                    "控除可能および学部生の履歴書がない限り、D要素。震えまたは醜い今はロレムが必要です。サッカー開発者のプロパガンダは、時には大衆投資の子供たちの願いのパフォーマンスをします。\n\nしかし、開発者は非常にニンジンです。今、多くの喉のカートン。トマトチリを喉の枕に調査してください。",
            },
            {
                id: "75c1fa44-8c39-48a0-9db7-b30c0ffc6606",
                class: "columns-3-narrow",
                header: "編集者レポート",
                url: "#",
                image: {
                    src: "assets/images/national-cancer-institute-YvvFRJgWShM-unsplash_336.jpg",
                    alt: "プレースホルダー",
                    width: "336",
                    height: "189",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "サッカーは、滅菌されたポットコースがたくさんあります。",
                type: "text",
                content:
                    "は大きく、製造業のを投資します。マスサピエンの喉またはテレビとですが、選択された製造.\n\nヴィタは、マウリスレンジジャスミンまたは開発者チョコレートを計画しています。サッカーの醜い喉、私の飲み物、どちらのツイッターの宿題もそれぞれ。",
            },
        ],
    },
    {
        id: "content-opinion-top-issues",
        name: "トップの問題",
        articles: [
            {
                id: "68c63699-7843-4f2c-8893-3cd0043ce6c7",
                class: "columns-3-balanced",
                header: "考え",
                image: {
                    src: "assets/images/rebe-pascual-SACRQSof7Qw-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "サッカー開発者のサッカーの大衆のニーズ。",
                type: "list",
                content: [
                    {
                        id: "240604e5-bec1-4618-96b2-0779e444bbd6",
                        content: "ニンジンへの直径のいくつかの直径。マウリスレンジジャスミンまたは地域の計画。",
                    },
                    {
                        id: "0c00a629-e255-4378-8a83-c03f7931c4ad",
                        content: "サスペンディスジョーは、発射ニンジンを強化することがあります。",
                    },
                    {
                        id: "1c1c8def-c6a4-46e1-abc3-41f5047fac43",
                        content: "学部生の悲しい笑顔またはまでの重要な直径。",
                    },
                    {
                        id: "58d833c6-a8c8-407a-9f19-beca0f8c162f",
                        content: "誰もがいない限り、バスケットボールまたはフットボールのジャスミンのパフォーマンス要素。",
                    },
                ],
            },
            {
                id: "f293245c-cbdc-4538-8ca8-0181ba5709a0",
                class: "columns-3-balanced",
                header: "ソーシャル解説",
                image: {
                    src: "assets/images/fanga-studio-bOfCOy3_4wU-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "アルコールの弓の矢印。",
                type: "list",
                content: [
                    {
                        id: "92224182-af6a-4b62-88cb-570784a44f48",
                        content: "ゲートウェイロレムが直径から航空会社のライオンの一部を柔らかくする場合。",
                    },
                    {
                        id: "a6afd1c2-8601-44c0-b0f4-1ce53c49c18e",
                        content: "パキスタン全体または週末のバレーボール要素の喉から。",
                    },
                    {
                        id: "a50daa85-285a-4352-95f0-110d84a29bfe",
                        content: "しかし、ウルナソース不動産栄養IDの地球。",
                    },
                    {
                        id: "81b0cb6e-a5d2-4520-9760-91dd4b87b416",
                        content: "最新の製造サッカーが走っています。ライオンインテガー、マレスアダまたは",
                    },
                ],
            },
            {
                id: "0f38830e-3f1d-43ee-9f24-dc3f1422e9d7",
                class: "columns-3-balanced",
                header: "特別プロジェクト",
                image: {
                    src: "assets/images/jakob-dalbjorn-cuKJre3nyYc-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "滅菌されたメンバーでない限り、妊娠中のugいを製造します。がゲームをターゲットにしました。",
                type: "text",
                content:
                    "ストリートは、各矢印唐辛子ニンジンの週末に描かれています。多くのをチョコレートは、今のところ喉のバリエッドサッカーです。ニブにあります。無料の週末ですが、明日のサッカーアークドゥイライブ。\n\nしかし、利便性がジャスミンを嫌うサッカーは嫌いですが、。サッカーの午後もありませんは、栄養開発者のサッカー明日開発者カートンです。有料のまでのチョコレートのティーンエイジャー。",
            },
        ],
    },
    {
        id: "content-opinon-trending",
        name: "トレンド",
        articles: [
            {
                id: "7ca7daac-f4d0-4a57-a396-b8bb485796b4",
                class: "columns-wrap",
                header: "世界中で",
                type: "excerpt",
                content: [
                    {
                        id: "8b9fef9b-1387-432b-9f0a-a4fbe8525c39",
                        image: {
                            src: "assets/images/dibakar-roy-K9JwokzSvrc-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "各施行の各執行は、アルコールの直径です。サッカー選手のソリシジンは今",
                    },
                    {
                        id: "dbbbe43b-354b-458e-832a-1a1de4e4a68c",
                        image: {
                            src: "assets/images/anatol-rurac-NeSj0i6HLak-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "サスペンディスジョーは時々あなたの車を非常に痛みさせます。かし枕。人生の要素チャットのアルコールを飲みます。",
                    },
                    {
                        id: "4d5f3465-3649-40d0-a15e-28b4c6c7a333",
                        image: {
                            src: "assets/images/anatol-rurac-b5t2lqeCGfA-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "ティーンエイジャーを走らせて、私のは何人かに注意しません。質量または。漏れの世話をすることは何もありません。マッサージは、時々無料のを強化しました。",
                    },
                ],
            },
            {
                id: "89639a03-5c46-45c1-ad54-ba8548521eea",
                class: "columns-wrap",
                header: "サポート",
                type: "excerpt",
                content: [
                    {
                        id: "ac384e2a-611f-4910-8c89-2922238dff84",
                        image: {
                            src: "assets/images/neil-thomas-SIU1Glk6v5k-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "空腹と醜い執行整数のニーズ。リスクがの都合の時に言った。ニンジンが強化されました。私のウルトレシーズモーリス震えとバスケットボール。選択されたレシピプレーヤーまたは価格。",
                    },
                    {
                        id: "c5622af2-af36-4d93-9fab-5fed3226f48c",
                        image: {
                            src: "assets/images/jon-tyson-ne2mqMgER8Y-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "各矢印唐辛子ニンジン。明日の温かい憎しみサッカーEUの価格。の価格は大きく、アーチを投資します。",
                    },
                    {
                        id: "1e5314da-3b79-4da7-a845-d3c27c37ba70",
                        image: {
                            src: "assets/images/nonresident-nizUHtSIrKM-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "私はあなたの子供の直径の週末の利便性が嫌いですが、執行。ゲームのボウラー、ゲームの弓の弓の要素。",
                    },
                ],
            },
            {
                id: "b4c36ecf-7d2f-4715-842c-a1fe99c0475e",
                class: "columns-wrap",
                header: "もっと知ってください",
                type: "excerpt",
                content: [
                    {
                        id: "af1969b9-e8de-4e1f-84b5-353ea124a6b0",
                        image: {
                            src: "assets/images/alev-takil-fYyYz38bUkQ-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "現在化学する必要はありません。空腹と醜い執行整数は、バナナが悲しいことをする必要があります。",
                    },
                    {
                        id: "ba3d22b7-a6e8-4f6e-a97a-ac179e4c44de",
                        image: {
                            src: "assets/images/bermix-studio-yUnSMBogWNI-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "大量のウリシーズ、ヘンドレリットの消費者マグナがそれを必要とする私の愛する人。",
                    },
                    {
                        id: "3724b29a-64a3-4426-9354-7f6026d5ce30",
                        image: {
                            src: "assets/images/pierre-bamin-lM4_Nmcj4Xk-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "生命の矢の地域要素とライオンの宿題として。パキスタンからスロートからバレーボールの要素が綴られています。",
                    },
                ],
            },
        ],
    },
    {
        id: "content-opinion-think-about-it",
        name: "それについて考えてください",
        articles: [
            {
                id: "a1034d17-1add-49f8-b258-27de86bea9e4",
                class: "columns-3-balanced",
                header: "メンタルヘルス",
                image: {
                    src: "assets/images/matthew-ball-3wW2fBjptQo-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "Olutpatと常に卒業した人生の開発者。マッサージジョーのパッチにすぎないこともあります。",
                type: "list",
                display: "bullets",
                content: [
                    {
                        id: "66f18c80-0f84-4713-ba04-ec7aa1f3441a",
                        content: "マクロフォトグラフィーIDゲートニブは明日滅菌しましたが、サッカー。バスケットボールでは、製造サッカーが笑い声を上げていません。",
                        url: "#",
                    },
                    {
                        id: "a446329a-425a-4599-81c7-a867ab764af9",
                        content: "今すぐ資金調達の大衆開発者を行ってください。ですが、シナリオではバナナを引きます。",
                        url: "#",
                    },
                    {
                        id: "273c6981-6b94-4b79-9017-5a8ee610450f",
                        content: "ドリンクアルコールライフエレメントチャット。彼が誰でも、バスケットボール妊娠臨床順序を投資することを強調します。",
                        url: "#",
                    },
                    {
                        id: "142b6b03-0141-443f-bb2f-06310fc3ff76",
                        content: "カートンチョコレート発酵です。明日はニブ・ヴェネナティスですが、サッカーは屋外調査を必要とします。",
                        url: "#",
                    },
                ],
            },
            {
                id: "c344dac6-35bf-44af-9c55-ae5ca7ab7f41",
                class: "columns-3-balanced",
                header: "より良い生活",
                image: {
                    src: "assets/images/peter-conlan-LEgwEaBVGMo-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "レクトゥス・モーリスのバスケットボールの入り口を置きます。学校のミサの過程でピーナッツ。",
                type: "list",
                display: "bullets",
                content: [
                    {
                        id: "434b9a09-048a-4389-963d-f1a9e28a2e0b",
                        content: "このコースでは、は栄養開発者です。しかし、私は時々ポットフィルムバレーレーンIDを卒業しました。",
                        url: "#",
                    },
                    {
                        id: "5d479d71-0510-46c7-a97e-96dfaac89f33",
                        content: "ランニングのugい大量開発者のバスケットボールピーナッツ。私の時間の資金調達マレスアダ栄養はありません。",
                        url: "#",
                    },
                    {
                        id: "c237c9c4-d382-4e70-8888-32fe5b57153b",
                        content: "非常に喉のライフ調査またはullamCorperです。または矢印までのティーンエイジャー。",
                        url: "#",
                    },
                    {
                        id: "1747a7d7-a717-4dc1-b972-aea76168bd6e",
                        content: "通りのこのコースで。価格の矢印、一部の男性はアルコールを飲みます。",
                        url: "#",
                    },
                ],
            },
            {
                id: "a1724b6d-085c-4467-b413-e3332a4a4af6",
                class: "columns-3-balanced",
                header: "正しい選択",
                image: {
                    src: "assets/images/vladislav-babienko-KTpSVEcU0XU-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "喉または従業員とEU。ニンジンの滅菌ポットのランニングには、チョコレートの漫画が必要になります。",
                type: "list",
                display: "bullets",
                content: [
                    {
                        id: "17e825fc-4471-405d-8134-3105d0d5c419",
                        content: "スマートチリのURNポートティターの範囲。明日の学部生がたくさん必要です。",
                        url: "#",
                    },
                    {
                        id: "dffa8c9a-0f03-4a0c-a1cb-fb26e0a74a49",
                        content: "エレメントフットボールの抗酸化物質のライオンポットの従業員。恐怖は便利なクマの時でした。",
                        url: "#",
                    },
                    {
                        id: "1c5c95cc-41e8-418b-9caa-f3e743b53fbf",
                        content: "牛肉以外の笑顔でパフォーマンスのスカートを嫌いではありません。",
                        url: "#",
                    },
                    {
                        id: "5be13fa0-0e42-47f1-8d7b-e24c24f78972",
                        content: "直径のまで。控除可能な場合を除き、パフォーマンス要素。",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-opinion-latest-media",
        name: "最新のメディア",
        articles: [
            {
                id: "c3ed8428-cf45-4f9d-86d1-391bd9e9ad80",
                class: "columns-1",
                type: "grid",
                content: [
                    {
                        id: "ce8185af-104d-4d9c-910b-8b96bcd6cf26",
                        image: {
                            src: "assets/images/daniel-staple-N320vzTBviA-unsplash_684.jpg",
                            alt: "プレースホルダー",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "時計",
                            },
                        },
                    },
                    {
                        id: "e3af13d9-da0e-4068-9e92-ca09bb0d9eea",
                        image: {
                            src: "assets/images/clem-onojeghuo-DoA2duXyzRM-unsplash_684.jpg",
                            alt: "プレースホルダー",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "時計",
                            },
                        },
                    },
                    {
                        id: "2c4f8f8c-cbe4-4a3f-9306-5142eea5a43d",
                        image: {
                            src: "assets/images/egor-myznik-GFHKMW6KiJ0-unsplash_684.jpg",
                            alt: "プレースホルダー",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "時計",
                            },
                        },
                    },
                    {
                        id: "de921ec9-3c73-4008-a124-d30477ffc0b7",
                        image: {
                            src: "assets/images/trung-thanh-LgdDeuBcgIY-unsplash_684.jpg",
                            alt: "プレースホルダー",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "時計",
                            },
                        },
                    },
                ],
            },
        ],
    },
    {
        id: "content-opinion-in-case-you-missed-it",
        name: "あなたがそれを逃した場合に備えて",
        articles: [
            {
                id: "9ecce31e-6d76-44c4-a518-b881b6877724",
                class: "columns-3-balanced",
                header: "批判的な考え",
                image: {
                    src: "assets/images/tingey-injury-law-firm-9SKhDFnw4c4-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "しかし、時にはサッカーの車がありません。宿題の開発者であるは湖ではなく、広告の矢が始まります。モーリスのサッカー開発者は嫌いです。",
                type: "list",
                content: [
                    {
                        id: "048f3e7e-882e-474b-a0eb-8cc82d599336",
                        content: "サッカーのニーズは今や多くのプレーを楽しんでいます。",
                    },
                    {
                        id: "f736ae42-3fe7-4fab-85dc-2922e272f2b5",
                        content: "ニンジンなどの重要な開発者は、滅菌された滅菌を嘆きます。",
                    },
                    {
                        id: "54266d53-a192-4922-936f-144431407990",
                        content: "の週末は抗酸化物質を嫌い、マウリスはたくさんのミサを憎んでいます。",
                    },
                    {
                        id: "268294f4-0cec-4074-9cc4-07a93fbe8b66",
                        content: "ライフマクロソースラシニアまたはエロスティルアック。",
                    },
                ],
            },
            {
                id: "f80bc40c-0c9c-4567-8b79-fd29ef77659b",
                class: "columns-3-balanced",
                header: "批判的思考",
                image: {
                    src: "assets/images/tachina-lee--wjk_SSqCE4-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "パフォーマンスロレムの門が柔らかい場合、革新的なライオンのように。",
                type: "list",
                content: [
                    {
                        id: "9ef95ded-e833-44ee-8cb4-6538078e97d4",
                        content: "抗酸化物質の場合、妊娠または谷。",
                    },
                    {
                        id: "915b97eb-9f89-4f5a-aeee-32a17b6f45da",
                        content: "どちらのサッカージャスミン要素も控除可能でない限り.",
                    },
                    {
                        id: "2f17a946-0402-4d3b-bce7-e8fdaedc7fbe",
                        content: "可能な限り控除可能でない限り、要素。ただし、Twitterの要素ですが、まだです。",
                    },
                    {
                        id: "733ff090-3c8c-47fb-895e-f5d63e9d0f3a",
                        content: "地域の要素への生命の矢印とライオンの宿題は直径として。バスケットボールの妊娠臨床臨床臨床栄養資産を投資する。",
                    },
                ],
            },
            {
                id: "1bb6984e-a18f-47b7-9bbb-6888b74b58da",
                class: "columns-3-balanced",
                header: "重要な行動",
                image: {
                    src: "assets/images/etienne-girardet-RqOyRtYGhLg-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "必須は、直径までニンジン療法を言った。",
                type: "list",
                content: [
                    {
                        id: "8ff75479-7c53-4fb2-a720-475a1974f64f",
                        content: "恐怖は、便利な時点で、の製造パッチでした。",
                    },
                    {
                        id: "92c8590a-8431-4007-9a35-518f9a3b0095",
                        content: "選手のみでチョコレートフットボールバスケットボール。酵母とケアと臨床栄養価。",
                    },
                    {
                        id: "5d805677-408b-4317-a93b-8a0de95b313a",
                        content: "大規模な生態学的に卒業した滅菌滅菌を嘆くいくつかの唐辛子ニンジンを服用するために。",
                    },
                    {
                        id: "b51989a3-ffbe-40b4-9cfb-e52db8c1e48c",
                        content: "サッカーは今や子供たちの喉です。私の人生と調査またはの非常に喉。",
                    },
                ],
            },
        ],
    },
    {
        id: "content-opinion-environmental-issues",
        name: "環境問題",
        articles: [
            {
                id: "d55b5489-7ed3-4215-9e45-ef5ae8072210",
                class: "columns-3-balanced",
                header: "地球温暖化",
                type: "articles-list",
                content: [
                    {
                        id: "d2cc2f04-fc60-4314-b1bd-aacee5b80eed",
                        title: "不安定なモニュリン環境移動の移動。",
                        content:
                            "への直径の滑ブルがたくさんあるまで、いくつかのものがあります。今すぐチャットしますが、サッカーのメンバーにお願いします。さまざまなまたは震えまたはターピスがローレムを必要としています。しかし、今はバナナを飲みます。ターゲットを絞ったバスケットボールですが、プロパガンダ。",
                    },
                    {
                        id: "fe657d1b-916c-4f59-b6f9-54d21ba90f07",
                        title: "人生の醜いミサですが、時間のバニーの要素ですが、笑顔です。",
                        content:
                            "ビューローの痛みは、非常にニンジンをローレムするために大きなニーズです。バスケットボールの妊娠は、臨床ヌラ栄養を投資するための臨床的です。妊娠したアークとマクロサッカーのコンバリスジャスミン。フィルムバレーは時々労働します。",
                    },
                    {
                        id: "48fa5839-11d9-4721-a8e2-f734734904a2",
                        title: "メイクアップ地域の栄養サッカー開発者の温度。キャンセルしますが、明日のサッカーアーク。",
                        content: "屋外ですが、サッカー開発者。スマートチリのポートティターの範囲。今、ターゲットに、私の喉の寿命バナナまたは。ターゲットを絞ったバスケットボールは今、プロパガンダ車です。現在、バレーボールサピエンとヌラ。",
                    },
                ],
            },
            {
                id: "dcb3d636-542f-49ea-aaa0-e829fc87ab3d",
                class: "columns-3-balanced",
                header: "リサイクル",
                type: "articles-list",
                content: [
                    {
                        id: "bd091840-fde1-44f6-8830-9b165cfa0b66",
                        title: "サッカー写真、臨床性能、様々な屋外カートンのウルトリシーのいずれかでない限り。",
                        content:
                            "顧客のチームのニンジンが必要です。チョコレートのティーンエイジャーは、価格のビーフサピエンまで。学部生の電子レンジの矢印を学びそうにする方法。各IDの直径またはバレーボールの要素はそうではありません。妊娠したアークと温度サッカーのコンバリスジャスミンをチャットしません。",
                    },
                    {
                        id: "7d052a73-7477-41d4-9b46-82f33e09fb2f",
                        title: "サラダの生態学的順序でチョコレート漫画モーリス。",
                        content: "マウリス・モーリスの利便性誰が資金を提供します。あなたがあなたの子供を憎むまで素敵な写真とサッカー。ビューロー妊娠中の化粧はそれぞれ臨床オルシではありません。必須のランニングニンジンの掃除。",
                    },
                    {
                        id: "1d6f6db3-f9d9-4fc2-ad08-0edcf39d5fd3",
                        title: "の資金調達。マッサージの顎のパッチ以外は時々設定されています.",
                        content:
                            "喪に服した滅菌された卒業した大規模な生態学的なポット航空会社。これは、出会い系製造範囲の通りを帯びていました。臨床チョコレートチリは常にこの地域で宿題が必要です。ポットまたは開発者に敷設するウォームアップでの笑いまたは。",
                    },
                ],
            },
            {
                id: "500a214a-8186-49bf-96f0-38e42014460b",
                class: "columns-3-balanced",
                header: "新しい研究",
                type: "articles-list",
                content: [
                    {
                        id: "23fe0c63-75fb-498d-a7f2-4e91b29530b7",
                        title: "マッサージの喉のパッチにすぎません。",
                        content:
                            "控除可能および学部生のマイクロ波プレイヤーがある場合。誰でもパフォーマンスママを嫌います。テレビはそれにターゲットを絞っていました。それはのティーンエイジャーを走らせています、私の愛する人は気にしません。残念ながら、臨床タンパク質への時間が嫌いです。",
                    },
                    {
                        id: "c14a8fd5-1a01-4e2e-8ca3-2b3f951dd211",
                        title: "多くの補給学部開発者。ロレムだが笑顔の微笑は調査なし。",
                        content:
                            "また、一部の製造業のサッカーは笑いを走らせていません。サッカーの悲しい老人とネタスの住民。高校のフラット。重要なのは、ヴィタエ電子レンジのサギッティスプレイヤーテキスタイルマティスCNNポットです。または笑顔や便利さを引っ張ります。マクロサッカージャスミンと温度。",
                    },
                    {
                        id: "f8abd77a-596c-4df7-9fa9-38d08f8b6516",
                        title: "効果。臨床週末のullamcorperは座っていないことを恐れています。",
                        content:
                            "ナムは今やロアムの痛みが必要ですが、今はバナナを引っ張ります。直径からのフェリーライオンの柔らかい層。デートライオンポットの従業員を置きます。には電子レンジが必要ですが、無料です。はゼロバナナ航空です。機器は、サッカーのugいのために明日の学部生をとても楽しくする必要があります。",
                    },
                ],
            },
        ],
    },
    {
        id: "content-opinion-underscored",
        name: "強調されています",
        articles: [
            {
                id: "8096212a-bfab-494b-b4d9-a04c2bd80b17",
                class: "columns-2-balanced",
                header: "これは最初です",
                type: "grid",
                content: [
                    {
                        id: "05d58548-eec8-4806-8935-a50a72d863cb",
                        image: {
                            src: "assets/images/alexander-kirov-YhDJXJjmxUQ-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "時々喉が家にいます。従業員は明日ウォームアップの憎しみを備えていません。憎しみの抗酸化物質モーリスは式の腫れの塊を座らせます。スマイルプルボックスのマクロ。マクロセットと写真がこれまでに引っ張られます。",
                        url: "#",
                    },
                    {
                        id: "d825b148-633e-46f6-9f25-5d2b1b42d926",
                        image: {
                            src: "assets/images/paola-chaaya-QrbuLFT6ypw-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "モンテスはマウスで生まれます。必須の航空会社では、スマートな病気やアークの笑顔でカジノが必要です。ジャスミンまたはエリートサーマルマウリス栄養バレーボールの範囲。製造のプールですが、アークはパフォーマンススカートを嫌いません。",
                        url: "#",
                    },
                ],
            },
            {
                id: "8945566e-82d2-419c-8ec5-750294e2aaf4",
                class: "columns-2-balanced",
                header: "この秒",
                type: "grid",
                content: [
                    {
                        id: "35ef50c4-f574-484f-bf93-0f9eb004b18b",
                        image: {
                            src: "assets/images/sean-lee-hDqRQmcjM3s-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "速報",
                            },
                        },
                        text: "コスタは現在最大のコングです。チャンピオンシップライブアルコールトリガードリンクとしてタンク。エコロジーからサッカー開発者のプロパガンダ。サッカーで醜い喉の喉のために私の飲み物。撮影して、常に写真を撮ってください。",
                        url: "#",
                    },
                    {
                        id: "3d2cb1ef-f74b-4eac-b237-c9ac0a0e94d4",
                        image: {
                            src: "assets/images/nathan-dumlao-laCrvNG3F_I-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "速報",
                            },
                        },
                        text: "いくつかのサラダの場合はありません。はに従います。ソースによって滅菌されたニブニスルソース。アースペレンテスクのフットボールティンカントマクロ最新の明日酵母。",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-opinon-what-matters-most",
        name: "最も重要なこと",
        articles: [
            {
                id: "2fe9dc69-e459-46d6-8b9b-8bce7c60f694",
                class: "columns-wrap",
                header: "議論",
                type: "excerpt",
                content: [
                    {
                        id: "e015fd9b-c112-4aec-895b-463080039812",
                        image: {
                            src: "assets/images/tatjana-petkevica-iad-dMBDdoo-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "ニブだがバレーボール電子レンジ妊娠局が卒業した。各矢印のディクタムストの通りの種類は重要です。私の非常に喉の人生のバナナまたはウラムコーパーはあなたの笑顔です。",
                    },
                    {
                        id: "e3910d58-0e1f-4ee1-872b-8bd39ec70833",
                        image: {
                            src: "assets/images/nathan-cima-TQuq2OtLBNU-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "検査はパフォーマンススカートが嫌いではありません。そして醜いバニーですが、時間はです。地域の整数チョコレートバリウスの笑い漫画の学部.",
                    },
                    {
                        id: "89525746-2a5c-426b-950f-8b8e7a0e77eb",
                        image: {
                            src: "assets/images/artur-voznenko-rwPIQQPz1ew-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "卒業した出荷は不動産です。著者または発酵において妊娠しています。明日は常にオクトルまたはキャリア期間よりもです。ニンジン航空会社には、賢い病気や弧の笑い声が必要です。",
                    },
                ],
            },
            {
                id: "fa068dc1-0a5c-459a-9e38-7fb8cd9d5fa5",
                class: "columns-wrap",
                header: "その価値はありますか？",
                type: "excerpt",
                content: [
                    {
                        id: "91eb5eba-6ce6-4376-b8a9-874a8e759285",
                        image: {
                            src: "assets/images/zac-gudakov-wwqZ8CM21gg-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "トリガーチョコレート。このライオンは、質量の質量の生活にありますが、要素。人生のコースの検査。利便性をキャンセルしますが、執行環境生態学的な栄養価の高い熱控除可能。",
                    },
                    {
                        id: "daedcebf-d529-4dc6-9215-ca7b83bc288f",
                        image: {
                            src: "assets/images/pat-whelen-68OkRwuOeyQ-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "一部のサラダと温度ではありません。それが多くの時間でない限り、何もありません。車両はありません。は私を必要としません。キャンセルしますが、明日サッカーアークDUIアルコールドリンク。ミネアポリスの学部開発者は、いくつかのチリのニンジンを嘆きます.",
                    },
                    {
                        id: "1bd419c1-0664-4b54-963b-fda397fecbf0",
                        image: {
                            src: "assets/images/tania-mousinho-YlpfE9uCakE-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "サッカーのために明日の学部生がたくさん必要です。プールからの便利なクマの時です。レクスマイクロ波lソースは、生命のソースによって滅菌されました。",
                    },
                ],
            },
            {
                id: "31082ef2-8a41-4ea5-9c40-3d87ff73ad5f",
                class: "columns-wrap",
                header: "早くやれよ",
                type: "excerpt",
                content: [
                    {
                        id: "90217b1a-7e75-4b34-aed5-6be1b2b8c016",
                        image: {
                            src: "assets/images/maksym-kaharlytskyi-Y0z9MyDsrU0-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "マティスオレンジポットまたは漫画。ビューロー妊娠中の化粧はそれぞれ臨床オルシではありません。恐れのために地域で滅菌される。",
                    },
                    {
                        id: "61b9356e-2ea7-4770-81b5-a6af21721fec",
                        image: {
                            src: "assets/images/maja-kochanowska-EiJQdDI_t_Y-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "地域の要素のために、生命とライオンの宿題の矢印。各矢印唐辛子はあなたの週末の写真です。サッカーバレージャスミンと温度。サッカーでは、私の飲み物または執行パスポート各法執行機関。",
                    },
                    {
                        id: "401e246d-ffda-4c74-897f-1889de7ffeb1",
                        image: {
                            src: "assets/images/patti-black-FnV-PjAYHCI-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "整数のバレーボール要素を味わうウルスはそうではありません。施行されているが、生態学的な栄養価の高い熱熱を施行してください。",
                    },
                ],
            },
        ],
    },
    {
        id: "content-opinion-hot-topics",
        name: "ホットな話題",
        articles: [
            {
                id: "20b1f11f-8da5-4614-82b9-80c15aed568c",
                class: "columns-2-balanced",
                header: "これは最初です",
                type: "grid",
                content: [
                    {
                        id: "106eea44-16f1-403d-b075-4baa5e5998e0",
                        image: {
                            src: "assets/images/rio-lecatompessy-cfDURuQKABk-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "は当時でした。支払われたサッカーサーマル電話。醜い執行整数にはバナナが必要です。チョコレートチョコレートフットボールはチョコレートです。すが、用です。大衆開発者に現在バレーボールサピエンに資金を提供しています。",
                        url: "#",
                    },
                    {
                        id: "952c96cc-a882-4100-b9c5-21572c70abef",
                        image: {
                            src: "assets/images/declan-sun-misAHv6YWkI-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "大衆には、プレーヤーのみのチリ漫画層の施行が必要です。メンバーは、サッカーサラダを綴ることができます。マクロジャスミンと温度。声明の屋外チョコレートまたは強化されたものでした。このソースビタヴィト科サピエンの栄養住民。",
                        url: "#",
                    },
                ],
            },
            {
                id: "662f09bf-45ab-445f-a096-cede68c5dab8",
                class: "columns-2-balanced",
                header: "この秒",
                type: "grid",
                content: [
                    {
                        id: "406e421a-7044-4256-964b-9decfcf6958d",
                        image: {
                            src: "assets/images/astronaud23-ox3t0m3PUqA-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "速報",
                            },
                        },
                        text: "予約済みマイクロ波無料写真が時々写真を撮る。さて、私の喉の命のバナナまたはウラムコーパー。栄養またはいくつかのサラダと温度のレシピ用。レシピ変数がニンジンの不動産があります。を脂肪を減らします。",
                        url: "#",
                    },
                    {
                        id: "f16fc9bc-ac9e-492b-b9fa-9512181bd45e",
                        image: {
                            src: "assets/images/markus-spiske-lUc5pRFB25s-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "速報",
                            },
                        },
                        text: "チュートリアルプレーヤー。それは、ライオンや生態学的なウルラムコルの現在の要素ではありません。ポットの著者にマイク用のバナナはありません。アルコールランニングパフォーマンスすべての漫画ニブトモーレーバレーボールロット。",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-opinion-paid-content",
        name: "有料コンテンツ",
        articles: [
            {
                id: "c7f1b2e8-3e7e-4cea-b8fd-97da6aaa217a",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "1f2b0751-1d26-420c-a4ab-dfe8189afa55",
                        image: {
                            src: "assets/images/sabri-tuzcu-kxR3hh0IRHU-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "自体はありません。サッカーの醜い執行価格のために、明日の学部生がとても楽しいです。直径ナム製造ロレムセッド笑いウルトレイシー。",
                    },
                ],
            },
            {
                id: "f047187b-7651-45f5-8e13-362d82b59e91",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "61856b32-0a27-4767-a624-9292b797d463",
                        image: {
                            src: "assets/images/cardmapr-nl-s8F8yglbpjo-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "臨床的臨床臨床臨床臨床臨床。彼が誰でも、バスケットボール妊娠臨床順序を投資することを強調します。",
                    },
                ],
            },
            {
                id: "fc748387-cfdb-4659-bf00-14984869c3f4",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "64853755-7212-46ff-b036-eb078a15e975",
                        image: {
                            src: "assets/images/leon-seibert-Xs3al4NpIFQ-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "しかし、明日サッカーアークドゥイライブ。機能的な現在、ロボルティスの喉がたくさんあります。車両はありません。しかし、サッカーの醜い喉、私の飲み物。",
                    },
                ],
            },
            {
                id: "ad88b542-6ac0-4525-b6be-581cb2b67762",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "809a6cab-ccb0-4270-9555-948eff9e7291",
                        image: {
                            src: "assets/images/sheelah-brennan-UOfERQF_pr4-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "キャリアがない限り、モーリスは今宿題です。プロパガンダ・モーリス・アウグエまたは妊娠中の著者。",
                    },
                ],
            },
        ],
    },
];
